import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const serviceV2: IMcAppType = {
  name: "serviceV2_KRAKEN",
  path: "/my/servicev2/:serviceType/:agreementId",
  description: "Service overview",
  parameters: {
    required: ["serviceType", "agreementId"],
    properties: {
      agreementId: CommonParameters.agreementId,
      serviceType: CommonParameters.serviceType,
    },
  },
  navFlow: NavFlow.STANDARD,
  title: "Service",
  parent: Tab.MORE,
  conditions: {
    intent: "serviceV2",
    customerType: CustomerType.kraken,
  },
  ignorePathMapping: true,
};
